import { useEffect, useMemo, useState } from 'react';
import { AppTable } from '@components/AppTable';
import {
  MultiAliasItemRow,
  MultiAliasComponentRow,
  itemColumns,
  calculateItem,
} from '@page-components/purchase-order';
import { BoldText, FlexRow, JustifyBetweenRow } from '@elements/Common';
import { Flag } from '@elements/Flag';
import { CommonUtility } from '@utility/common';

export function BulkPORow({ purchaseOrder }) {
  const columns = useMemo(() => itemColumns, []);

  const [items, setItems] = useState([]);
  const [components, setComponents] = useState([]);
  const [upcQty, setUPCQty] = useState({});
  const [componentQty, setComponentQty] = useState({});

  useEffect(() => {
    const temp = purchaseOrder.items.map(item => {
      const t = { ...item };
      t.item_upc = t.upc;
      t.attributes = t.aliases.map(x => {
        const newAttribute = {
          ...x,
          ...x.attributes,
        };
        delete newAttribute.attributes;
        return newAttribute;
      });
      return t;
    });
    setItems(temp);

    const tempComponents = (purchaseOrder.components || []).map(item => {
      const t = {
        ...item,
        ...item.component,
      };
      t.attributes = t.aliases.map(x => {
        const newAttribute = {
          ...x,
          ...x.attributes,
        };
        delete newAttribute.attributes;
        return newAttribute;
      });
      t.currentAttributes = [...t.attributes];
      t._id = t.component_id;
      delete t.component;
      return t;
    });
    setComponents(tempComponents);
  }, [purchaseOrder]);

  useEffect(() => {
    const t = {};
    items.forEach(item => {
      // @ts-expect-error - TS2339: Property 'upc' does not exist on type 'never'.
      if (!upcQty[item.upc] && (item.attributes || []).length) {
        const tempAttributes = {};
        // @ts-expect-error - TS2339: Property 'attributes' does not exist on type 'never'.
        item.attributes.forEach(attribute => {
          const temp = {
            alias: attribute.alias,
            ctn_qty: Math.floor(attribute.qty / attribute.units_per_carton),
            qty: attribute.qty,
            grossWeight: attribute.carton_gross_weight?.value || 0,
          };
          tempAttributes[attribute.alias] = temp;
        });
        const tempTotal = { ...calculateItem(Object.values(tempAttributes)) };

        // @ts-expect-error - TS2339: Property 'prices' does not exist on type 'never'.
        const tempPrices = [...item.prices].sort((a, b) => b.moq - a.moq);
        // @ts-expect-error - TS2339: Property 'current_price' does not exist on type '{ ctn_qty: number; qty: number;...
        tempTotal.current_price = tempPrices.find(
          x => x.moq <= tempTotal.qty,
        )?.price;
        // @ts-expect-error - TS2339: Property 'total' does not exist on type '{ ctn_qty: number; qty: number; }'.
        tempTotal.total = tempTotal.qty * tempTotal.current_price;

        // @ts-expect-error - TS2339: Property 'upc' does not exist on type 'never'.
        t[item.upc] = {
          aliases: { ...tempAttributes },
          // @ts-expect-error - TS2339: Property 'item_upc' does not exist on type 'never'.
          item_upc: item.item_upc,
          ...tempTotal,
        };
      }
    });
    const updated = {
      ...upcQty,
      ...t,
    };
    setUPCQty(updated);
  }, [items]);

  useEffect(() => {
    const t = {};
    components.forEach(item => {
      // @ts-expect-error - TS2339: Property '_id' does not exist on type 'never'.
      if (!componentQty[item._id] && (item.attributes || []).length) {
        const tempAttributes = {};
        // @ts-expect-error - TS2339: Property 'attributes' does not exist on type 'never'.
        item.attributes.forEach(attribute => {
          const temp = {
            alias: attribute.alias,
            ctn_qty: Math.floor(attribute.qty / attribute.units_per_carton),
            qty: attribute.qty,
          };
          tempAttributes[attribute.alias] = temp;
        });
        const tempTotal = { ...calculateItem(Object.values(tempAttributes)) };
        // @ts-expect-error - TS2339: Property 'prices' does not exist on type 'never'.
        const tempPrices = [...(item.prices || [])].sort(
          (a, b) => b.moq - a.moq,
        );
        // @ts-expect-error - TS2339: Property 'current_price' does not exist on type '{ ctn_qty: number; qty: number;...
        tempTotal.current_price =
          tempPrices.find(x => x.moq <= tempTotal.qty)?.price || 0;
        // @ts-expect-error - TS2339: Property 'total' does not exist on type '{ ctn_qty: number; qty: number; }'.
        tempTotal.total = tempTotal.qty * tempTotal.current_price;

        // @ts-expect-error - TS2339: Property '_id' does not exist on type 'never'.
        t[item._id] = {
          aliases: { ...tempAttributes },
          // @ts-expect-error - TS2339: Property '_id' does not exist on type 'never'.
          _id: item._id,
          ...tempTotal,
        };
      }
    });
    const updated = {
      ...componentQty,
      ...t,
    };
    setComponentQty(updated);
  }, [components]);

  return (
    <>
      <JustifyBetweenRow className="sk:my-5!">
        <FlexRow>
          <Flag width={30} height={20} name={purchaseOrder?.supplier.country} />
          <h3 className="sk:m-0! sk:ml-2!">
            {purchaseOrder?.supplier?.supplier_name}
          </h3>
        </FlexRow>
        <FlexRow>
          <BoldText>
            Total Items:{' '}
            {CommonUtility.numberWithCommas(purchaseOrder.total_items)}
          </BoldText>
          <BoldText className="sk:m-0! sk:ml-2!">
            Price: {CommonUtility.currencyFormat(purchaseOrder.price)}
          </BoldText>
        </FlexRow>
      </JustifyBetweenRow>
      <AppTable
        RowComponent={
          // @ts-expect-error - TS2739: Type '{ showPrediction: false; readOnly: true; upcQty: {}; canTakeAction: false;...
          <MultiAliasItemRow
            showPrediction={false}
            readOnly
            upcQty={upcQty}
            canTakeAction={false}
            isPublic
          />
        }
        data={items}
        // @ts-expect-error - TS2322: Type '({ text: string; width: number; key: string; sortKey?: undefined; componen...
        columns={columns}
        keyField="upc"
      />
      {(components || []).length > 0 && (
        <>
          <AppTable
            RowComponent={
              // @ts-expect-error - TS2740: Type '{ readOnly: true; componentQty: {}; canTakeAction: boolean; isPublic: true...
              <MultiAliasComponentRow
                readOnly
                componentQty={componentQty}
                canTakeAction={false}
                isPublic
              />
            }
            data={components}
            // @ts-expect-error - TS2322: Type '({ text: string; width: number; key: string; sortKey?: undefined; componen...
            columns={columns}
          />
        </>
      )}
    </>
  );
}
